import(/* webpackMode: "eager" */ "/www/app/apps/client/app/(app)/content/[spaceIdentifier]/layout.tsx");
